import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the creation of the API key',
  name: 'account_api_key_create',
  params: [
    {
      description: 'The ID of the API key',
      name: 'api_key_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the API key',
      name: 'api_key_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
